var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 15.5968V5.34148C4 4.6006 4.59695 4 5.33333 4H14.6667C15.4031 4 16 4.6006 16 5.34148V12.0489C16 12.7898 15.4031 13.3904 14.6667 13.3904H7.3075C6.90245 13.3904 6.51937 13.5756 6.26634 13.8938L4.71235 15.8482C4.47614 16.1452 4 15.9772 4 15.5968Z",
    stroke: "#2D3643"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 6,
    height: 1,
    rx: 0.5,
    fill: "#2D3643"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 10,
    width: 6,
    height: 1,
    rx: 0.5,
    fill: "#2D3643"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcons);
export default __webpack_public_path__ + "static/media/Message-icons.ee66483b31424aa34f97064eb5188cc0.svg";
export { ForwardRef as ReactComponent };